import React, { useEffect } from "react";
import { Tab, Tabs, TabPanel, TabList } from "react-tabs";
import { useState } from "react";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { useForm } from "react-hook-form";
import TableSkeleton from "../../AllotedMaster/TableSkeleton";
import { AllShiftMaster } from "../../../Apis/shiftMasterApi";
import {
  CircleWiseExistingGvp,
  ZoneWiseCollectionPointReportResult,
  ZoneWiseExistingGvp,
  TotalExistingGvp,
  CircleWiseTotalExistingGvp,
  GetAllNotClearedCollectionTransaction,
  GetAllClearedCollectionTransactionNewApi,
  GetAllClearedNotInShift,
  GetAllClearedHotspotTransactionNewApi,
  GetAllTotalClearedNewApi,
  CircleWiseCollectionPointReportResultNew,
} from "../../../Apis/gvpClearanceReportApi";
import { useNavigate } from "react-router-dom";
import isGHMC, { formattedDate, getCurrentDateTime1 } from "../../../Common/helper/helpar";
import { getOneMonthPastDate, getTodayDate } from "../../AssetVehicle/utils/helpers";
import { getMasterAPIStore } from "../../../../utils/getMasterAPIStore";
import { CorporationStore } from "../../corporation_master/CorporationStore";
import Select from "react-select";
function GVPsReport() {
  const { shiftData } = getMasterAPIStore();
  // Zone Wise GVPs Report
  const GVPDate = localStorage.getItem("GVPDate");
  const GVPShift = localStorage.getItem("GVPShift");
  //
  const GVPCircleDate = localStorage.getItem("GVPCircleDate");
  const GVPCircleShift = localStorage.getItem("GVPCircleShift");
  const {
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const { UserCorporations, fetchUserCorporations } = CorporationStore();
  const [formInput, setFormInput] = useState({
    Date: GVPDate || getCurrentDateTime(),
    shiftId: GVPShift || 1,
    corporationIds: [],
  });

  const [formInput1, setFormInput1] = useState({
    Date: GVPCircleDate || getCurrentDateTime(),
    shiftId: GVPCircleShift || 1,
    corporationIds: [],
  });

  const [selectedTab, setSelectedTab] = useState(() => {
    const savedTab = localStorage.getItem("GvpselectedTab");
    return savedTab ? parseInt(savedTab, 10) : 0;
  });
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const [isOptionsLoading1, setIsOptionsLoading1] = useState(false);
  const [getZoneReport, setgetZoneReport] = useState([]);
  const [getCircleReport, setgetCircleReport] = useState([]);
  const [shiftType, setShiftType] = useState([]);
  const isProd = isGHMC();

  const getShiftName = (shiftId) => {
    const shift = shiftType.find((s) => s.shiftId === parseInt(shiftId));
    return shift ? shift.shiftName : "N/A";
  };

  const fetchShift = async () => {
    try {
      // const response = await AllShiftMaster();
      setShiftType(shiftData);
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    fetchShift();
  }, [shiftData])

  useEffect(() => {
    fetchUserCorporations();
  }, [])

  const handleTabSelect = (index) => {
    setSelectedTab(index);
    localStorage.setItem("GvpselectedTab", index);
  };

  const zoneColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      format: (row, rowIndex) => rowIndex + 1,
      width: "70px",
    },
    {
      name: "Corporation",
      selector: (row) => row["corporationName"],
      cell: (row) => <span>{row["corporationName"] || " "}</span>,
      width: "130px",
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      cell: (row) => (
        <span
          style={{ color: row.zoneName === "Total" ? "black" : "blue", cursor: "pointer" }}
          onClick={() => row.zoneName !== "Total" && handleZoneClick(row)}
        >
          {row["zoneName"]}
        </span>
      ),
    },
    {
      name: "Existing GVPs",
      selector: (row) => row["existingCP"],
      width: "120px",
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalExistingGVPClick();
            } else {
              handleExistingGVPClick(row);
            }
          }}
        >
          {row["existingCP"]}
        </span>
      ),
    },
    {
      name: <>No.of GVPs Cleared</>,
      selector: (row) => row["clearedCP"],
      width: "120px",
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalGvpClearedClick();
            } else {
              handleGvpClearedClick(row);
            }
          }}
        >
          {row["clearedCP"]}
        </span>
      ),
    },
    {
      name: <>GVPs Cleared<br />Percentage</>,
      selector: (row) => row["clearedPercentage"],
      cell: (row) => <span>{row["clearedPercentage"]}%</span>,
      width: "120px"
    },

    {
      name: <>GVPs Not<br />Cleared</>,
      selector: (row) => row["pendingCP"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalGvpNotClearedClick();
            } else {
              handleZoneGvpNotClearedClick(row);
            }
          }}
        >
          {row["pendingCP"]}
        </span>
      ),
      width: '120px'
    },
    {
      name: <>GVPs Not Cleared<br />Percentage</>,
      selector: (row) => row["pendingPercentage"],
      cell: (row) => <span>{row["pendingPercentage"]}%</span>,
      width: "120px",
    },
    {
      name: <>No.of Hotspots Cleared</>,
      selector: (row) => row["clearedHotspot"],
      width: "120px",
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalZoneHotspotClearedClick();
            } else {
              handleZoneHotspotClearedClick(row);
            }
          }}
        >
          {row["clearedHotspot"]}
        </span>
      ),
    },
    {
      name: <>Extra GVPs Cleared <br />(Not In Current Shift)</>,
      selector: (row) => row["clearedCPNotInShift"],
      width: "120px",
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalGvpClearedNoShiftClick();
            } else {
              handleGvpClearedNotShiftClick(row);
            }
          }}
        >
          {row["clearedCPNotInShift"]}
        </span>
      ),
    },
    {
      name: <>Total Cleared</>,
      selector: (row) => row["totalCleared"],
      width: "120px",
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalAllGVPClearedClick();
            } else {
              handleZoneGVPTotalClearedClick(row);
            }
          }}
        >
          {row["totalCleared"]}
        </span>
      ),
    },
    {
      name: <>Total Cleared %</>,
      selector: (row) => row["totalClearedPercentage"],
      cell: (row) => <span>{row["totalClearedPercentage"]}%</span>,
      width: "120px",
    },
  ];


  const circleColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      format: (row, rowIndex) => rowIndex + 1,
      width: "70px",
    },
    {
      name: "Corporation",
      selector: (row) => row["corporationName"],
      cell: (row) => <span>{row["corporationName"] || " "}</span>,
      width: "130px",
    },
    {
      name: "Circle",
      selector: (row) => row["circleName"],
    },
    {
      name: "Existing GVPs",
      selector: (row) => row["existingCP"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleTotalExistingGVPClickCircle();
            } else {
              handleExistingGVPClickCircle(row);
            }
          }}
        >
          {row["existingCP"]}
        </span>
      ),
      width: "120px",
    },
    {
      name: <>No.of GVPs Cleared</>,
      selector: (row) => row["clearedCP"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleTotalClearedGVPClickCircle();
            } else {
              handleClearedGVPClickCircle(row);
            }
          }}
        >
          {row["clearedCP"]}
        </span>
      ),
      width: "120px",
    },
    {
      name: <>GVPs Cleared Percentage</>,
      selector: (row) => row["clearedPercentage"],
      cell: (row) => <span>{row["clearedPercentage"]}%</span>,
    },
    // {
    //   name: <>Cleared Not <br/>In CP Shift</>,
    //   selector: (row) => row["clearedCPNotInShift"],
    //   width: "120px",
    //   cell: (row) => (
    //     <span
    //       style={{ color: "blue", cursor: "pointer" }}
    //       onClick={() => {
    //         if (row.circleName === "Total") {
    //           handleTotalCircleGvpClearedNoShiftClick(); // New Circle-specific handler
    //         } else {
    //           handleCircleGvpClearedNotShiftClick(row); // New Circle-specific handler
    //         }
    //       }}
    //     >
    //       {row["clearedCPNotInShift"]}
    //     </span>
    //   ),
    // },
    {
      name: <>GVPs Not Cleared</>,
      selector: (row) => row["pendingCP"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleCircleTotalGvpNotClearedClick();
            } else {
              handleCircleGvpNotClearedClick(row);
            }
          }}
        >
          {row["pendingCP"]}
        </span>
      ),
    },
    {
      name: <>GVPs Not Cleared Percentage</>,
      selector: (row) => row["pendingPercentage"],
      cell: (row) => <span>{row["pendingPercentage"]}%</span>,
      width: "120px",
    },
    {
      name: <>No.of Hotspots Cleared</>,
      selector: (row) => row["clearedHotspot"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleTotalCircleHotspotClearedClick();
            } else {
              handleCircleHotspotClearedClick(row);
            }
          }}
        >
          {row["clearedHotspot"]}
        </span>
      ),
      width: "120px",
    },
    {
      name: <>Extra GVPs Cleared <br />(Not In Current Shift)</>,
      selector: (row) => row["clearedCPNotInShift"],
      width: "120px",
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalGvpClearedNoShiftClick1();
            } else {
              handleGvpClearedNotShiftClick1(row);
            }
          }}
        >
          {row["clearedCPNotInShift"]}
        </span>
      ),
    },
    {
      name: <>Total Cleared</>,
      selector: (row) => row["totalCleared"],
      width: "120px",
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleTotalCircleAllGVPClearedClick(); // New Circle-specific handler
            } else {
              handleCircleGVPTotalClearedClick(row); // New Circle-specific handler
            }
          }}
        >
          {row["totalCleared"]}
        </span>
      ),
    },
    {
      name: <>Total Cleared %</>,
      selector: (row) => row["totalClearedPercentage"],
      cell: (row) => <span>{row["totalClearedPercentage"]}%</span>,
      width: "120px",
    },
  ];
  const searchZoneReport = async (data) => {
    setIsOptionsLoading1(true);
    setIsOptionsLoading(true);
    try {
      const res = await ZoneWiseCollectionPointReportResult({
        Date: formInput.Date,
        OwnerTypeId: formInput.ownerTypeId,
        ShiftId: formInput.shiftId,
        CorporationId: formInput.corporationIds,
      });
      const zoneDataResponse = res.data.map((zoneData) => ({
        ...zoneData,
        zone: zoneData.zoneName,
        clearedPercentage: zoneData.existingCP > 0 ? ((zoneData.clearedCP / zoneData.existingCP) * 100).toFixed(2) : 0,
        pendingPercentage: zoneData.existingCP > 0 ? ((zoneData.pendingCP / zoneData.existingCP) * 100).toFixed(2) : 0,
        totalClearedPercentage: zoneData.existingCP > 0 ? ((zoneData.totalCleared / zoneData.existingCP) * 100).toFixed(2) : 0,
        gvpHotspotClearedPercentage: zoneData.existingCP > 0 ? (((zoneData.clearedCP + zoneData.clearedHotspot) / zoneData.existingCP) * 100).toFixed(2) : 0,
      }));
      setgetZoneReport(zoneDataResponse);
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading1(false);
      setIsOptionsLoading(false);
    }
  };

  const searchCircleReport = async (data) => {
    setIsOptionsLoading(true);
    try {
      const res = await CircleWiseCollectionPointReportResultNew({
        Date: formInput1.Date,
        ShiftId: formInput1.shiftId,
        zoneId: "",
        CorporationId: formInput1.corporationIds,
      });
      const circleDataResponse = res.data.map((circleData) => ({
        ...circleData,
        circle: circleData.circleName,
        clearedPercentage: circleData.existingCP > 0 ? ((circleData.clearedCP / circleData.existingCP) * 100).toFixed(2) : 0,
        pendingPercentage: circleData.existingCP > 0 ? ((circleData.pendingCP / circleData.existingCP) * 100).toFixed(2) : 0,
        totalClearedPercentage: circleData.existingCP > 0 ? ((circleData.totalCleared / circleData.existingCP) * 100).toFixed(2) : 0,
        gvpHotspotClearedPercentage: circleData.existingCP > 0 ? (((circleData.clearedCP + circleData.clearedHotspot) / circleData.existingCP) * 100).toFixed(2) : 0,
      }));
      setgetCircleReport(circleDataResponse);
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  useEffect(() => {
    // Call API based on selected tab
    if (selectedTab === 0) {
      searchZoneReport();
    } else if (selectedTab === 1) {
      setIsOptionsLoading(true); // Set loader before API call
      searchCircleReport();
    }
  }, [selectedTab]);

  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
      callback(searchZoneReport);
      callback(searchCircleReport);
    }
  };
  const downloadZoneAsExcel = async () => {
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Zone Wise GVPs Report ${formattedDate(formInput.Date)} & ${getShiftName(formInput.shiftId)} - (at ${getCurrentDateTime1()})`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    const boldFont = { bold: true };

    const downloadDateTime = `Reported on: ${formattedDates} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5);
    dateTimeRow.getCell(3).font = boldFont;
    dateTimeRow.getCell(3).alignment = { horizontal: "center" };

    const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
    worksheet.mergeCells(2, 3, 2, 5);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 5) {
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    worksheet.addRow([""]);

    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Corporation",
      "Zone",
      "Existing GVPs",
      "No of GVPs Cleared",
      "GVPs Cleared Percentage",
      "GVPs Not Cleared",
      "GVPs Not Cleared Percentage",
      "No of Hotspots Cleared",
      "Extra GVPs Cleared (Not In Current Shift)",
      "Total Cleared",
      "Total Cleared %",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 12) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
        };
      }
    });

    let totalTotalCP = 0;
    let totalExistingGVPs = 0;
    let totalClearedGVPs = 0;
    let totalClearedHotspot = 0;
    let totalPendingCP = 0;
    let totalCleared = 0;
    let totalClearedCPNotInShift = 0; // Add variable to track total

    getZoneReport.forEach((item, index) => {
      totalTotalCP += item.totalCP || 0;
      totalExistingGVPs += item.existingCP || 0;
      totalClearedGVPs += item.clearedCP || 0;
      totalClearedHotspot += item.clearedHotspot || 0;
      totalPendingCP += item.pendingCP || 0;
      totalCleared += item.totalCleared || 0;
      totalClearedCPNotInShift += item.clearedCPNotInShift || 0; // Sum clearedCPNotInShift

      const gvpHotspotClearedPercentage = item.existingCP > 0 ? (((item.clearedCP + item.clearedHotspot) / item.existingCP) * 100) : 0;
      const totalClearedPercentage = item.existingCP > 0 ? ((item.totalCleared / item.existingCP) * 100).toFixed(2) : 0;

      worksheet.addRow([
        index + 1,
        item.corporationName ?? "N/A",
        item.zoneName,
        item.existingCP,
        item.clearedCP,
        item.clearedPercentage + "%",
        item.pendingCP,
        item.pendingPercentage + "%",
        item.clearedHotspot,
        item.clearedCPNotInShift,
        item.totalCleared,
        totalClearedPercentage + "%",
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.alignment = { horizontal: "left" };
      });
    });

    const totalClearedPercentage = totalExistingGVPs > 0 ? ((totalCleared / totalExistingGVPs) * 100).toFixed(2) : 0;
    const totalPercentage = totalExistingGVPs > 0 ? ((totalClearedGVPs / totalExistingGVPs) * 100).toFixed(2) : 0;
    const totalPendingPercentage = totalExistingGVPs > 0 ? ((totalPendingCP / totalExistingGVPs) * 100).toFixed(2) : 0;
    const totalGvpHotspotPercentage = totalExistingGVPs > 0 ? (((totalClearedGVPs + totalClearedHotspot) / totalExistingGVPs) * 100).toFixed(2) : 0;

    const totalRow = worksheet.addRow([
      "",
      "",
      "Total",
      totalExistingGVPs,
      totalClearedGVPs,
      totalPercentage + "%",
      totalPendingCP,
      totalPendingPercentage + "%",
      totalClearedHotspot,
      totalClearedCPNotInShift,
      totalCleared,
      totalClearedPercentage + "%",
    ]);

    totalRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
    });

    worksheet.columns = [
      { width: 5 },
      { width: 30 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 40 },
      { width: 40 },
      { width: 40 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "GVPsZoneWiseReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const downloadCircleAsExcel = async () => {
    const currentDate = new Date();
    const formattedCircleDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Circle Wise GVPs Report as on ${formattedDate(formInput1.Date)} - ${getShiftName(formInput1.shiftId)} - (at ${getCurrentDateTime1()})`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Circles");

    const boldFont = { bold: true };

    const downloadDateTime = `Reported on: ${formattedCircleDate} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5);
    dateTimeRow.getCell(3).font = boldFont;
    dateTimeRow.getCell(3).alignment = { horizontal: "center" };

    const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
    worksheet.mergeCells(2, 3, 2, 6);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 7) {
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    worksheet.addRow([""]);

    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Corporation",
      "Circle",
      "Existing GVPs",
      "No of GVPs Cleared",
      "GVPs Cleared Percentage",
      "GVPs Not Cleared",
      "GVPs Not Cleared Percentage",
      "No of Hotspots Cleared",
      "Extra GVPs Cleared (Not In Current Shift)",
      "Total Cleared",
      "Total Cleared %",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 12) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
        };
      }
    });

    let totalTotalCP = 0;
    let totalExistingGVPs = 0;
    let totalClearedGVPs = 0;
    let totalClearedHotspot = 0;
    let totalPendingCP = 0;
    let totalCleared = 0;
    let totalClearedCPNotInShift = 0;

    getCircleReport.forEach((item, index) => {
      totalTotalCP += item.totalCP || 0;
      totalExistingGVPs += item.existingCP || 0;
      totalClearedGVPs += item.clearedCP || 0;
      totalClearedHotspot += item.clearedHotspot || 0;
      totalPendingCP += item.pendingCP || 0;
      totalCleared += item.totalCleared || 0;
      totalClearedCPNotInShift += item.clearedCPNotInShift || 0;

      const totalClearedPercentage = item.existingCP > 0 ? ((item.totalCleared / item.existingCP) * 100).toFixed(2) : 0;
      const gvpHotspotClearedPercentage = item.existingCP > 0 ? (((item.clearedCP + item.clearedHotspot) / item.existingCP) * 100).toFixed(2) : 0;

      worksheet.addRow([
        index + 1,
        item.corporationName ?? "N/A",
        item.circleName ?? "N/A",
        item.existingCP ?? "N/A",
        item.clearedCP ?? "N/A",
        item.clearedPercentage + "%" ?? "N/A",
        item.pendingCP ?? "N/A",
        item.pendingPercentage + "%" ?? "N/A",
        item.clearedHotspot ?? "N/A",
        item.clearedCPNotInShift ?? "N/A",
        item.totalCleared ?? "N/A",
        totalClearedPercentage + "%" ?? "N/A",
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.alignment = { horizontal: "left" };
      });
    });

    const totalClearedPercentage = totalExistingGVPs > 0 ? ((totalCleared / totalExistingGVPs) * 100).toFixed(2) : 0;
    const totalPercentage = totalExistingGVPs > 0 ? ((totalClearedGVPs / totalExistingGVPs) * 100).toFixed(2) : 0;
    const totalPendingPercentage = totalExistingGVPs > 0 ? ((totalPendingCP / totalExistingGVPs) * 100).toFixed(2) : 0;
    const totalGvpHotspotPercentage = totalExistingGVPs > 0 ? (((totalClearedGVPs + totalClearedHotspot) / totalExistingGVPs) * 100).toFixed(2) : 0;

    const totalRow = worksheet.addRow([
      "",
      "",
      "Total",
      totalExistingGVPs,
      totalClearedGVPs,
      totalPercentage + "%",
      totalPendingCP,
      totalPendingPercentage + "%",
      totalClearedHotspot,
      totalClearedCPNotInShift,
      totalCleared,
      totalClearedPercentage + "%",
    ]);

    totalRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
    });

    worksheet.columns = [
      { width: 5 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 40 },
      { width: 40 },
      { width: 40 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "GVPsCircleWiseReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };


  useEffect(() => {
    // Store formInput in local storage
    localStorage.setItem("formInput", JSON.stringify(formInput));
  }, [formInput]);

  const handleZoneClick = async (zone) => {
    setIsOptionsLoading(true);
    try {
      const res = await CircleWiseCollectionPointReportResultNew({
        Date: formInput.Date,
        ShiftId: formInput.shiftId,
        zoneId: zone.zoneId,
      });
      navigate("/gvp-inner-circle-report", { state: { data: res.data, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
      // { state: {data: response.data, deleteOption: false} }
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleExistingGVPClick = async (zone) => {
    setIsOptionsLoading(true);
    const Date = formInput.Date;
    const startDate = `${Date}`;
    try {
      const res = await ZoneWiseExistingGvp({
        Date: formInput.Date,
        ShiftId: formInput.shiftId,
        zoneId: zone.zoneId,
        corporationId: formInput.corporationIds,
      });

      const requestData = {
        date: startDate,
        // endDate,
        ZoneId: zone.zoneId,
        ShiftId: formInput.shiftId,
        corporationId: formInput.corporationIds.join(","),
      };
      console.log(requestData)
      navigate("/gvp-inner-existing-report", { state: { data: res.data, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalExistingGVPClick = async () => {
    // searchCircleReport(zoneId);
    setIsOptionsLoading(true);
        const Date = formInput.Date;
    const startDate = `${Date}`;
    try {
      const res = await TotalExistingGvp({
        Date: formInput.Date,
        ShiftId: formInput.shiftId,
        corporationId: formInput.corporationIds,
      });

      const requestData = {
        date: startDate,
        ShiftId: formInput.shiftId,
      };
      console.log(requestData)
      navigate("/gvp-inner-existing-report", { state: { data: res.data, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleExistingGVPClickCircle = async (circle) => {
    setIsOptionsLoading(true);
    try {
      const res = await CircleWiseExistingGvp({
        Date: formInput1.Date,
        ShiftId: formInput1.shiftId,
        circleId: circle.circleId,
        corporationId: formInput1.corporationIds,
      });
      navigate("/gvp-inner-existing-report", { state: { data: res.data, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalExistingGVPClickCircle = async () => {
    setIsOptionsLoading(true);
    try {
      const res = await CircleWiseTotalExistingGvp({
        Date: formInput1.Date,
        ShiftId: formInput1.shiftId,
        corporationId: formInput1.corporationIds,
      });
      // navigate("/gvp-inner-existing-report", { state: res.data,formatDate:formInput1.Date });
      navigate("/gvp-inner-existing-report", { state: { data: res.data, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });

    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleClearedGVPClickCircle = async (circle) => {
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = formInput1.Date;
    // Concatenate start and end times with the date
    const startDate = `${Date}`;
    const endDate = `${Date}T${endTime}`;

    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: startDate,
        // endDate,
        circleId: circle.circleId,
        ShiftId: formInput1.shiftId,
        corporationId: formInput1.corporationIds.join(","),
      };
      const response = await GetAllClearedCollectionTransactionNewApi(requestData);
      navigate("/gvp-inner-cleared-report", { state: { data: response.data, deleteOption: true, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalClearedGVPClickCircle = async () => {
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = formInput1.Date;
    // Concatenate start and end times with the date
    const startDate = `${Date}`;
    const endDate = `${Date}T${endTime}`;
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: startDate,
        // endDate,
        ShiftId: formInput1.shiftId,
        corporationId: formInput1.corporationIds.join(","),
      };
      const response = await GetAllClearedCollectionTransactionNewApi(
        requestData
      );
      navigate("/gvp-inner-cleared-report", { state: { data: response.data, deleteOption: true, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleGvpClearedClick = async (zone) => {
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = formInput.Date;
    const startDate = `${Date}`;
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: startDate,
        // endDate,
        ZoneId: zone.zoneId,
        ShiftId: formInput.shiftId,
        corporationId: formInput.corporationIds.join(","),
      };
      const response = await GetAllClearedCollectionTransactionNewApi(requestData);
      navigate("/gvp-inner-cleared-report", { state: { data: response.data, deleteOption: true, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) }, isValid: true });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalGvpClearedClick = async () => {
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = formInput.Date;

    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: Date,
        // endDate,
        ShiftId: formInput.shiftId,
        corporationId: formInput.corporationIds.join(","),
      };
      const response = await GetAllClearedCollectionTransactionNewApi(
        requestData
      );
      navigate("/gvp-inner-cleared-report", { state: { data: response.data, deleteOption: true, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };




  const handleGvpClearedNotShiftClick = async (zone) => {
    const Date = formInput.Date;
    const startDate = `${Date}`;
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: startDate,
        // endDate,
        ZoneId: zone.zoneId,
        ShiftId: formInput.shiftId,
      };
      const response = await GetAllClearedNotInShift(requestData);
      navigate("/gvp-inner-cleared-not-shift-report", { state: { data: response.data, deleteOption: true, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) }, isValid: true });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleGvpClearedNotShiftClick1 = async (zone) => {
    const Date = formInput1.Date;
    const startDate = `${Date}`;
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: startDate,
        // endDate,
        CircleId: zone.circleId,
        ShiftId: formInput1.shiftId,
        corporationId: formInput1.corporationIds.join(","),
      };
      const response = await GetAllClearedNotInShift(requestData);
      navigate("/gvp-inner-cleared-not-shift-report", { state: { data: response.data, deleteOption: true, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) }, isValid: true });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };



  const handleTotalGvpClearedNoShiftClick = async (zone) => {
    const Date = formInput.Date;
    const startDate = `${Date}`;
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: startDate,
        // endDate,
        // ZoneId: zone.zoneId,
        ShiftId: formInput.shiftId,
        corporationId: formInput.corporationIds.join(","),
      };
      const response = await GetAllClearedNotInShift(requestData);
      navigate("/gvp-inner-cleared-not-shift-report", { state: { data: response.data, deleteOption: true, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) }, isValid: true });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };


  const handleTotalGvpClearedNoShiftClick1 = async (zone) => {
    const Date = formInput1.Date;
    const startDate = `${Date}`;
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: startDate,
        // endDate,
        // ZoneId: zone.zoneId,
        ShiftId: formInput1.shiftId,
        corporationId: formInput1.corporationIds.join(","),
      };
      const response = await GetAllClearedNotInShift(requestData);
      navigate("/gvp-inner-cleared-not-shift-report", { state: { data: response.data, deleteOption: true, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) }, isValid: true });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };


  const handleCircleGvpClearedNotShiftClick = async (circle) => {
    const Date = formInput1.Date;
    const startDate = `${Date}`;
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: startDate,
        // endDate,
        circleId: circle.circleId,
        ShiftId: formInput1.shiftId,
        corporationId: formInput1.corporationIds.join(","),
      };
      const response = await GetAllClearedNotInShift(requestData);
      navigate("/gvp-inner-cleared-not-shift-report", { state: { data: response.data, deleteOption: true, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) }, isValid: true });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };



  const handleTotalCircleGvpClearedNoShiftClick = async (zone) => {
    const Date = formInput1.Date;
    const startDate = `${Date}`;
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: startDate,
        // endDate,
        // ZoneId: zone.zoneId,
        ShiftId: formInput1.shiftId,
        corporationId: formInput1.corporationIds.join(","),
      };
      const response = await GetAllClearedNotInShift(requestData);
      navigate("/gvp-inner-cleared-not-shift-report", { state: { data: response.data, deleteOption: true, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) }, isValid: true });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };



  const handleZoneGvpNotClearedClick = async (zone) => {
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = formInput.Date;
    // Concatenate start and end times with the date
    const startDate = `${Date}T${startTime}`;
    const endDate = `${Date}T${endTime}`;
    // console.log(startDate, "startdate");
    // console.log(endDate, "endDate");

    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: formInput.Date,
        ZoneId: zone.zoneId,
        ShiftId: formInput.shiftId,
        corporationId: formInput.corporationIds.join(","),
      };
      const response = await GetAllNotClearedCollectionTransaction(requestData);
      navigate("/gvp-not-cleared-inner-report", { state: { data: response.data, deleteOption: true, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };




  const handleZoneGVPTotalClearedClick = async (zone) => {
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = formInput.Date;
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: formInput.Date,
        ZoneId: zone.zoneId,
        ShiftId: formInput.shiftId,
        corporationId: formInput.corporationIds.join(","),
      };
      const response = await GetAllTotalClearedNewApi(requestData);
      console.log(response.data)
      navigate("/gvp-total-cleared-inner-report", { state: { data: response.data, deleteOption: true, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };



  const handleTotalAllGVPClearedClick = async (zone) => {
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = formInput.Date;
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: formInput.Date,
        // ZoneId: zone.zoneId,
        ShiftId: formInput.shiftId,
        corporationId: formInput.corporationIds.join(","),
      };
      const response = await GetAllTotalClearedNewApi(requestData);
      navigate("/gvp-total-cleared-inner-report", { state: { data: response.data, deleteOption: true, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };




  const handleCircleGVPTotalClearedClick = async (circle) => {
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = formInput.Date;
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: formInput1.Date,
        CircleId: circle.circleId,
        ShiftId: formInput1.shiftId,
        corporationId: formInput1.corporationIds.join(","),
      };
      const response = await GetAllTotalClearedNewApi(requestData);
      console.log(response.data)
      navigate("/gvp-total-cleared-inner-report", { state: { data: response.data, deleteOption: true, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };



  const handleTotalCircleAllGVPClearedClick = async (zone) => {
    const startTime = "00:00";
    const endTime = "23:59";
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: formInput1.Date,
        // ZoneId: zone.zoneId,
        ShiftId: formInput1.shiftId,
        corporationId: formInput1.corporationIds.join(","),
      };
      const response = await GetAllTotalClearedNewApi(requestData);
      navigate("/gvp-total-cleared-inner-report", { state: { data: response.data, deleteOption: true, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };


  const handleCircleGvpNotClearedClick = async (zone) => {
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = formInput.Date;
    // Concatenate start and end times with the date
    const startDate = `${Date}T${startTime}`;
    const endDate = `${Date}T${endTime}`;
    // console.log(startDate, "startdate");
    // console.log(endDate, "endDate");

    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: formInput1.Date,
        CircleId: zone.circleId,
        ShiftId: formInput1.shiftId,
        corporationId: formInput1.corporationIds.join(","),
      };
      const response = await GetAllNotClearedCollectionTransaction(requestData);
      navigate("/gvp-not-cleared-inner-report", { state: { data: response.data, deleteOption: true, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };


  const handleTotalGvpNotClearedClick = async () => {
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = formInput.Date;
    // Concatenate start and end times with the date
    const startDate = `${Date}T${startTime}`;
    const endDate = `${Date}T${endTime}`;
    // console.log(startDate, "startdate");
    // console.log(endDate, "endDate");

    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: formInput.Date,
        ShiftId: formInput.shiftId,
        corporationId: formInput.corporationIds.join(","),
      };
      const response = await GetAllNotClearedCollectionTransaction(
        requestData
      );
      navigate("/gvp-not-cleared-inner-report", { state: { data: response.data, deleteOption: true, formatDate: formInput1.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };


  const handleCircleTotalGvpNotClearedClick = async () => {
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = formInput.Date;
    // Concatenate start and end times with the date
    const startDate = `${Date}T${startTime}`;
    const endDate = `${Date}T${endTime}`;
    // console.log(startDate, "startdate");
    // console.log(endDate, "endDate");

    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: formInput1.Date,
        ShiftId: formInput1.shiftId,
        corporationId: formInput1.corporationIds.join(","),
      };
      const response = await GetAllNotClearedCollectionTransaction(
        requestData
      );
      navigate("/gvp-not-cleared-inner-report", { state: { data: response.data, deleteOption: true, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };



  const handleZoneHotspotClearedClick = async (zone) => {
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = formInput.Date;
    const shiftId = formInput.shiftId;
    // Concatenate start and end times with the date
    const startDate = `${Date}`;

    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: startDate,
        // endDate,
        ZoneId: zone.zoneId,
        shiftId,
        corporationId: formInput.corporationIds.join(","),
      };
      const response = await GetAllClearedHotspotTransactionNewApi(
        requestData
      );
      navigate("/gvp-inner-cleared-report", { state: { data: response.data, deleteOption: false, isValid: true, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalZoneHotspotClearedClick = async () => {
    const Date = formInput.Date;
    const shiftId = formInput.shiftId;
    // Concatenate start and end times with the date
    const startDate = `${Date}`;
    // const endDate = `${Date}T${endTime}`;

    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: startDate,
        shiftId,
        corporationId: formInput.corporationIds.join(","),
      };
      const response = await GetAllClearedHotspotTransactionNewApi(
        requestData
      );
      navigate("/gvp-inner-cleared-report", { state: { data: response.data, deleteOption: false, isValid: true, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleCircleHotspotClearedClick = async (circle) => {
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = formInput1.Date;
    const startDate = `${Date}`;
    const endDate = `${Date}T${endTime}`;
    const shiftId = formInput1.shiftId;
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: startDate,
        // endDate,
        circleId: circle.circleId,
        shiftId,
        corporationId: formInput1.corporationIds.join(","),
      };
      const response = await GetAllClearedHotspotTransactionNewApi(requestData);
      navigate("/gvp-inner-cleared-report", { state: { data: response.data, deleteOption: false, isValid: true, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalCircleHotspotClearedClick = async () => {
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = formInput1.Date;
    const startDate = `${Date}`;
    const endDate = `${Date}T${endTime}`;
    const shiftId = formInput1.shiftId;
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: startDate,
        // endDate,
        shiftId,
        corporationId: formInput1.corporationIds.join(","),
      };
      const response = await GetAllClearedHotspotTransactionNewApi(requestData);
      navigate("/gvp-inner-cleared-report", { state: { data: response.data, deleteOption: false, isValid: true, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const calculateGVPTotals = (data) => {
    const totals = {
      sno: "Total",
      zoneName: "Total",
      totalCP: 0,
      existingCP: 0,
      clearedCP: 0,
      clearedPercentage: 0,
      clearedCPNotInShift: 0, // Add this field to track the total
      pendingCP: 0,
      pendingPercentage: 0,
      clearedHotspot: 0,
      totalCleared: 0,
      totalClearedPercentage: 0,
      gvpHotspotClearedPercentage: 0,
    };

    data.forEach((row) => {
      totals.totalCP += row.totalCP || 0;
      totals.existingCP += row.existingCP || 0;
      totals.clearedCP += row.clearedCP || 0; // Sum clearedCPNotInShift
      totals.pendingCP += row.pendingCP || 0;
      totals.clearedHotspot += row.clearedHotspot || 0;
      totals.clearedCPNotInShift += row.clearedCPNotInShift || 0;
      totals.totalCleared += row.totalCleared || 0;
    });

    totals.clearedPercentage = totals.existingCP > 0 ? ((totals.clearedCP / totals.existingCP) * 100).toFixed(2) : 0;
    totals.pendingPercentage = totals.existingCP > 0 ? ((totals.pendingCP / totals.existingCP) * 100).toFixed(2) : 0;
    totals.totalClearedPercentage = totals.existingCP > 0 ? ((totals.totalCleared / totals.existingCP) * 100).toFixed(2) : 0;
    totals.gvpHotspotClearedPercentage = totals.existingCP > 0 ? (((totals.clearedCP + totals.clearedHotspot) / totals.existingCP) * 100).toFixed(2) : 0;

    return totals;
  };

  const totalZoneRow = calculateGVPTotals(getZoneReport);
  const GVPDataWithTotal = [...getZoneReport, totalZoneRow];

  const calculateCircleGVPTotals = (data) => {
    const totals = {
      sno: "Total",
      circleName: "Total",
      totalCP: 0,
      existingCP: 0,
      clearedCP: 0,
      clearedPercentage: 0,
      clearedCPNotInShift: 0,
      pendingCP: 0,
      pendingPercentage: 0,
      clearedHotspot: 0,
      totalCleared: 0,
      totalClearedPercentage: 0,
      gvpHotspotClearedPercentage: 0,
    };

    data.forEach((row) => {
      totals.totalCP += row.totalCP || 0;
      totals.existingCP += row.existingCP || 0;
      totals.clearedCP += row.clearedCP || 0;
      totals.clearedCPNotInShift += row.clearedCPNotInShift || 0;
      totals.pendingCP += row.pendingCP || 0;
      totals.clearedHotspot += row.clearedHotspot || 0;
      totals.totalCleared += row.totalCleared || 0;
    });

    totals.clearedPercentage = totals.existingCP > 0 ? ((totals.clearedCP / totals.existingCP) * 100).toFixed(2) : 0;
    totals.pendingPercentage = totals.existingCP > 0 ? ((totals.pendingCP / totals.existingCP) * 100).toFixed(2) : 0;
    totals.totalClearedPercentage = totals.existingCP > 0 ? ((totals.totalCleared / totals.existingCP) * 100).toFixed(2) : 0;
    totals.gvpHotspotClearedPercentage = totals.existingCP > 0 ? (((totals.clearedCP + totals.clearedHotspot) / totals.existingCP) * 100).toFixed(2) : 0;

    return totals;
  };

  const totalCircleRow = calculateCircleGVPTotals(getCircleReport);
  const GVPCircleDataWithTotal = [...getCircleReport, totalCircleRow];

  const handleMapViewClick = () => {
    navigate("/gvp-clearance-map-view"); // Navigate to the /map-view route
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="d-flex align-items-center justify-content-between mt-3">
              <h4 class="text-start m-0">GVPs Report</h4>
              <button
                className="btn btn-excel"
                onClick={handleMapViewClick}
              >
                Map View
              </button>
            </div>
            <div className="page-header">
              <div className="card">
                <div className="card-body p-3">
                  {/* <span style={{ display: "flex-Start" }}><h5>GVPs Report</h5></span> */}
                  <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
                    <TabList style={{ display: "none" }}>
                      <Tab />
                      <Tab />
                    </TabList>
                    <div
                      style={{
                        position: "relative",
                        display: "inline-flex",
                        backgroundColor: "#f1f3f5",
                        borderRadius: "8px",
                        border: "1px solid #e4e6e9",
                        padding: "4px",
                        marginBottom: "16px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "4px",
                          bottom: "4px",
                          left: selectedTab === 0 ? "4px" : "calc(50% + 2px)",
                          width: "calc(50% - 6px)",
                          borderRadius: "5px",
                          backgroundColor: isProd ? "#1565C0" : "#c0392b",
                          boxShadow: "0 1px 6px rgba(0,0,0,0.18)",
                          transition: "left 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
                          zIndex: 0,
                        }}
                      />
                      <button
                        type="button"
                        onClick={() => handleTabSelect(0)}
                        style={{
                          padding: "7px 18px",
                          background: "transparent",
                          border: "none",
                          outline: "none",
                          cursor: "pointer",
                          fontWeight: selectedTab === 0 ? "600" : "500",
                          fontSize: "13px",
                          color: selectedTab === 0 ? "#fff" : "#6c757d",
                          position: "relative",
                          zIndex: 1,
                          transition: "color 0.35s ease",
                          userSelect: "none",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <i className="fa-solid fa-layer-group me-2" />
                        Zone Wise GVPs Report
                      </button>
                      <button
                        type="button"
                        onClick={() => handleTabSelect(1)}
                        style={{
                          padding: "7px 18px",
                          background: "transparent",
                          border: "none",
                          outline: "none",
                          cursor: "pointer",
                          fontWeight: selectedTab === 1 ? "600" : "500",
                          fontSize: "13px",
                          color: selectedTab === 1 ? "#fff" : "#6c757d",
                          position: "relative",
                          zIndex: 1,
                          transition: "color 0.35s ease",
                          userSelect: "none",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <i className="fa-solid fa-circle-dot me-2" />
                        Circle Wise GVPs Report
                      </button>
                    </div>
                    <TabPanel>
                      <div className="row mt-3 align-items-center">
                        <div className="col-md-10">
                          <form
                            onSubmit={handleSubmit(searchZoneReport)}
                            onKeyDown={(e) => {
                              handleKeyDown(e, handleSubmit);
                            }}
                          >
                            <div
                              class="row align-items-center"
                              style={{ textAlign: "justify" }}
                            >
                              <div class="col-md-3 ">
                                <label htmlFor="Date">Date:</label>
                                <input
                                  type="date"
                                  name="date"
                                  value={formInput.Date}
                                  style={inputStyle}
                                  className="form-control"
                                  min={getOneMonthPastDate()}
                                  max={getTodayDate()}
                                  onChange={(e) => {
                                    setFormInput({
                                      ...formInput,
                                      Date: e.target.value,
                                    });
                                    localStorage.setItem(
                                      "GVPDate",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <div class="col-md-3 ">
                                <label htmlFor="ShiftId">Shift</label>
                                <select
                                  className="form-select"
                                  style={inputStyle2}
                                  name="shiftName"
                                  id="shiftName"
                                  value={formInput.shiftId}
                                  onChange={(e) => {
                                    setFormInput({
                                      ...formInput,
                                      shiftId: e.target.value,
                                    });
                                    localStorage.setItem(
                                      "GVPShift",
                                      e.target.value
                                    );
                                  }}
                                >
                                  {shiftType.filter(shift => shift.isActive).map((shift, index) => {
                                    return <option key={index} value={shift.shiftId}>{shift.shiftName}</option>
                                  })}
                                </select>
                              </div>
                              <div class="col-md-3">
                                <label htmlFor="gvpZoneCorpIds">Corporation</label>
                                <Select
                                  inputId="gvpZoneCorpIds"
                                  isMulti
                                  options={UserCorporations.map((corp) => ({
                                    value: corp.corporationId,
                                    label: corp.corporationName,
                                  }))}
                                  value={UserCorporations.filter((corp) =>
                                    (formInput.corporationIds || []).includes(corp.corporationId)
                                  ).map((corp) => ({
                                    value: corp.corporationId,
                                    label: corp.corporationName,
                                  }))}
                                  onChange={(selected) =>
                                    setFormInput({
                                      ...formInput,
                                      corporationIds: (selected || []).map((c) => c.value),
                                    })
                                  }
                                  placeholder="Select Corporation(s)"
                                  isClearable
                                  menuPortalTarget={document.body}
                                  menuPosition="fixed"
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    control: (base) => ({
                                      ...base,
                                      borderRadius: "0px",
                                      backgroundColor: "#ececec",
                                      border: "1px solid #E2E2E2",
                                      minHeight: "38px",
                                    }),
                                    placeholder: (base) => ({ ...base, marginLeft: "6px" }),
                                    indicatorSeparator: (base) => ({ ...base, backgroundColor: "#fff" }),
                                  }}
                                />
                              </div>
                              <div class="col-md-3 ">
                                <button
                                  type="submit"
                                  className={`btn mt-4 mr-2 ${isProd ? "search-ghmc" : "search-swm"
                                    }`}
                                >
                                  Search
                                </button>
                                <button
                                  type="submit"
                                  className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"
                                    }`}
                                  onClick={() => {
                                    localStorage.removeItem("GVPDate");
                                    localStorage.removeItem("GVPShift");
                                    setFormInput({
                                      Date: getCurrentDateTime(),
                                      shiftId: 1,
                                      corporationIds: [],
                                    });
                                  }}
                                >
                                  Reset
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div className="col-md-2">
                          <div className="text-end ">
                            <button
                              className="btn btn-excel ms-auto mt-4"
                              onClick={downloadZoneAsExcel}
                            >
                              <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                              Excel
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="card mt-3">
                        <div className=" ">
                          <div className="top-header">
                            <span> Zone Wise GVPs Report as on {formattedDate(formInput.Date)} - {getShiftName(formInput.shiftId)}
                              - (at {getCurrentDateTime1()})
                            </span>
                          </div>
                          {isOptionsLoading1 ? <TableSkeleton /> : (
                            <CustomDataTable
                              data={GVPDataWithTotal}
                              columns={zoneColumns}
                              link={true}
                              search={true}
                              select={true}
                              date={formInput.Date}
                              gvpClearence={true}
                            />
                          )}
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="row mt-3 align-items-center">
                        <div className="col-md-10">
                          <form
                            onSubmit={handleSubmit(searchCircleReport)}
                            onKeyDown={(e) => {
                              handleKeyDown(e, handleSubmit);
                            }}
                          >
                            <div
                              class="row align-items-center"
                              style={{ textAlign: "justify" }}
                            >
                              <div class="col-md-3">
                                <label htmlFor="Date">Date:</label>
                                <input
                                  type="date"
                                  name="date"
                                  value={formInput1.Date}
                                  style={inputStyle}
                                  className="form-control"
                                  min={getOneMonthPastDate()}
                                  max={getTodayDate()}
                                  onChange={(e) => {
                                    setFormInput1({
                                      ...formInput1,
                                      Date: e.target.value,
                                    });
                                    localStorage.setItem(
                                      "GVPCircleDate",
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                              <div class="col-md-3 ">
                                <label htmlFor="ShiftId">Shift</label>
                                <select
                                  className="form-select"
                                  style={inputStyle2}
                                  name="shiftName"
                                  id="shiftName"
                                  value={formInput1.shiftId}
                                  onChange={(e) => {
                                    setFormInput1({
                                      ...formInput1,
                                      shiftId: e.target.value,
                                    });
                                    localStorage.setItem(
                                      "GVPCircleShift",
                                      e.target.value
                                    );
                                  }}
                                >
                                  {shiftType.filter(shift => shift.isActive).map((shift, index) => {
                                    return <option key={index} value={shift.shiftId}>{shift.shiftName}</option>
                                  })}
                                </select>
                              </div>
                              <div class="col-md-3">
                                <label htmlFor="gvpCircleCorpIds">Corporation</label>
                                <Select
                                  inputId="gvpCircleCorpIds"
                                  isMulti
                                  options={UserCorporations.map((corp) => ({
                                    value: corp.corporationId,
                                    label: corp.corporationName,
                                  }))}
                                  value={UserCorporations.filter((corp) =>
                                    (formInput1.corporationIds || []).includes(corp.corporationId)
                                  ).map((corp) => ({
                                    value: corp.corporationId,
                                    label: corp.corporationName,
                                  }))}
                                  onChange={(selected) =>
                                    setFormInput1({
                                      ...formInput1,
                                      corporationIds: (selected || []).map((c) => c.value),
                                    })
                                  }
                                  placeholder="Select Corporation(s)"
                                  isClearable
                                  menuPortalTarget={document.body}
                                  menuPosition="fixed"
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    control: (base) => ({
                                      ...base,
                                      borderRadius: "0px",
                                      backgroundColor: "#ececec",
                                      border: "1px solid #E2E2E2",
                                      minHeight: "38px",
                                    }),
                                    placeholder: (base) => ({ ...base, marginLeft: "6px" }),
                                    indicatorSeparator: (base) => ({ ...base, backgroundColor: "#fff" }),
                                  }}
                                />
                              </div>
                              <div class="col-md-3">
                                <button
                                  type="submit"
                                  className={`btn mt-4 mr-2 ${isProd ? "search-ghmc" : "search-swm"
                                    }`}
                                >
                                  Search
                                </button>
                                <button
                                  type="submit"
                                  className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"
                                    }`}
                                  onClick={() => {
                                    localStorage.removeItem("GVPCircleDate");
                                    localStorage.removeItem("GVPCircleShift");
                                    setFormInput1({
                                      Date: getCurrentDateTime(),
                                      shiftId: 1,
                                      corporationIds: [],
                                    });
                                  }}
                                >
                                  Reset
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div className="col-md-2">
                          <div className="text-end ">
                            <button
                              className="btn btn-excel ms-auto mt-4"
                              onClick={downloadCircleAsExcel}
                            >
                              <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                              Excel
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="card mt-3">
                        <div className="">
                          <div className="top-header">
                            <span> Circle Wise GVPs Report as on {formattedDate(formInput1.Date)} - {getShiftName(formInput1.shiftId)} - (at {getCurrentDateTime1()})</span>
                          </div>
                          {isOptionsLoading ? <TableSkeleton /> : (
                            <CustomDataTable
                              data={GVPCircleDataWithTotal}
                              columns={circleColumns}
                              link={true}
                              search={true}
                              select={true}
                              date={formInput1.Date}
                              gvpClearence={true}
                              filterFunction={(data) =>
                                data.filter(
                                  (item) => item.status === 1 || item.status === 0
                                )
                              }
                            />
                          )}
                        </div>
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GVPsReport;

const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const inputStyle = {
  border: "1px solid #E2E2E2",
  padding: "15px",
  borderRadius: "0px",
};

const inputStyle2 = {
  border: "1px solid #E2E2E2",
  // padding: "15px",
  borderRadius: "0px",
};
